module.exports = __webpack_public_path__ + "static/media/let10.3b25050c.JPG";